import React, { useEffect, useState } from "react";

const ShowFolder = () => {
  const [files, setFiles] = useState([]); // Ensure it's an array
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const fetchFiles = async () => {
    setLoading(true);
    setError("");
    try {
      const response = await fetch("https://api.wiczka.eu/api/data/list/", {
        headers: {
          Authorization: `Token ${localStorage.getItem("token")}`,
        },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch files");
      }

      const data = await response.json();

      if (data.files && Array.isArray(data.files)) {
        setFiles(data.files); // Extract 'files' array from response
      } else {
        setFiles([]); // Set empty array if response structure is wrong
      }
    } catch (err) {
      setError(err.message);
      setFiles([]); // Prevent crash by setting empty array
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFiles();
  }, []);

  return (
    <div className="show-folder-container">
      <h2>Pliki Świadectw</h2>
      {loading && <p className="loading-text">Loading...</p>}
      {error && <p className="error-message">{error}</p>}
      {!loading && files.length === 0 && <p className="empty-text">Brak plików.</p>}
      <ul className="file-list">
        {files.map((file, index) => (
          <li
            key={index}
            className="file-item"
            onClick={() => window.open(file, "_blank")}
          >
            {file.split("/").pop()}
          </li>
        ))}
      </ul>
      <button className="refresh-button" onClick={fetchFiles}>Odśwież</button>
    </div>
  );
};

export default ShowFolder;
